import { createFileRoute } from '@tanstack/react-router'
import { ListTransactionPage } from '_/features/finance/ui/pages/list-transaction-page'

export const Route = createFileRoute('/_authenticated/finance/transactions')({
	staticData: { title: 'finance_tab_transactions' },
	component: ListTransactionPage,
})
